/** Minimal markdown → HTML for pipeline AI output. */
export function renderMarkdown(md: string): string {
  let html = md
    .replace(/^### (.+)$/gm, "<h3 class='text-base font-semibold text-foreground mt-4 mb-2'>$1</h3>")
    .replace(/^## (.+)$/gm, "<h2 class='text-lg font-bold text-foreground mt-5 mb-2'>$1</h2>")
    .replace(/^# (.+)$/gm, "<h1 class='text-xl font-bold text-foreground mt-5 mb-3'>$1</h1>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, "<code class='rounded bg-muted/30 px-1 py-0.5 text-xs font-mono'>$1</code>")
    .replace(/\[(.+?)\]\((.+?)\)/g, "<a href='$2' class='text-brand hover:underline' target='_blank' rel='noopener'>$1</a>")
    .replace(/^- (.+)$/gm, "<li class='ml-4 text-muted-foreground'>$1</li>")
    .replace(/^---$/gm, "<hr class='my-4 border-border' />")
    .replace(/\n\n/g, "</p><p class='text-muted-foreground leading-relaxed text-sm'>")
    .replace(/\n/g, "<br />");
  return `<p class='text-muted-foreground leading-relaxed text-sm'>${html}</p>`;
}
